<template>
    <Tab :title="$trad.brand.navigation.general">
        <TextInputBloc :label="$t('brand.name')" :min-length="MIN_LENGTH_NAME" :required="true" v-model="datas.name"></TextInputBloc>
        <FormSectionTitle :title="'Images'"></FormSectionTitle>
        <ImageUploadBloc :origin="logoPath" :required="true" v-model="datas.logo" :label="'Logo Image'"></ImageUploadBloc>
        <ImageUploadBloc :origin="heroImgPath" v-model="datas.heroImg" :label="'Hero Image'"></ImageUploadBloc>

        <FormSectionTitle :title="'Look and feel'"></FormSectionTitle>

        <div class="form-group row">
            <label class="col-4 col-form-label label">{{ $t("brand.brandTheme") }}</label>
            <div class="col-8 themeBloc">
                <span class="themeSelecter lightTheme" :class="[datas.theme === 'light' ? 'choosen' : '']" @click="selectTheme('light');">
                    Light</span
                >
                <span class="themeSelecter darkTheme" :class="[datas.theme === 'dark' ? 'choosen' : '']" @click="selectTheme('dark');"> Dark </span>
            </div>
        </div>
        <FormSectionTitle :title="$t('brand.colorTitle')" :description="$t('brand.colorFormatInfo')"></FormSectionTitle>

        <TextInputBloc
            :label="`1 (${$t('brand.backgroundColor')})`"
            :required="true"
            v-model="datas.backgroundColor"
            :validator="FORM_VALIDATORS.color"
            :max-length="MAX_LENGTH_COLOR"
        ></TextInputBloc>
        <TextInputBloc
            :label="`2 (${$t('brand.linkColor')})`"
            :required="true"
            v-model="datas.linksColor"
            :validator="FORM_VALIDATORS.color"
            :max-length="MAX_LENGTH_COLOR"
        ></TextInputBloc>
        <TextInputBloc
            :label="`3 (${$t('brand.rem3rchLogo')})`"
            :required="true"
            v-model="datas.thirdColor"
            :validator="FORM_VALIDATORS.color"
            :max-length="MAX_LENGTH_COLOR"
        ></TextInputBloc>
        <TextInputBloc
            :label="`4 (${$t('brand.fourthColor')})`"
            :required="true"
            v-model="datas.fourthColor"
            :validator="FORM_VALIDATORS.color"
            :max-length="MAX_LENGTH_COLOR"
        ></TextInputBloc>
    </Tab>
</template>

<script>
import TextInputBloc from "@/components/ui/Form/TextInputBloc";
import ImageUploadBloc from "@/components/ui/Form/ImageUploadBloc";
import Globals from "@/components/globals";
import FormSectionTitle from "@/components/ui/Form/FormSectionTitle";
import { MAX_LENGTH_COLOR, MIN_LENGTH_NAME } from "@/utils/string";
import Tab from "@/components/admin/brand/tabs/Tab";

export default {
    name: "GeneralForm",
    data: () => ({
        MAX_LENGTH_COLOR,
        MIN_LENGTH_NAME
    }),
    model: {
        prop: "datas",
        event: "input"
    },
    components: {
        TextInputBloc,
        ImageUploadBloc,
        FormSectionTitle,
        Tab
    },
    methods: {
        selectTheme(theme) {
            if (theme === this.datas.theme) return false;
            this.datas.theme = theme;
        }
    },
    computed: {
        imagePath() {
            return this.datas && this.datas.imgPath && Globals.getBaseUrl() + this.datas.imgPath;
        },
        logoPath() {
            return this.imagePath && this.datas.logo && `${this.imagePath}${this.datas.logo}`;
        },
        heroImgPath() {
            return this.imagePath && this.datas.heroImg && `${this.imagePath}${this.datas.heroImg}`;
        }
    },
    props: {
        datas: {
            type: Object,
            required: true
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../../assets/css/themes";
section {
    display: grid;
    grid-template-columns: 1fr;
    grid-row-gap: 8px;
}
.themeBloc {
    .themeSelecter {
        display: inline-block;
        width: 80px;
        margin: 0px 5px;
        cursor: pointer;
        border: 1.5px #999 solid;
        text-align: center;
        padding: 8px 0px;
        font-family: "Oswald", Sans-Serif;
        transition: all 0.3s ease;

        &.darkTheme {
            background-color: map_get($dark, second-background);
            color: map_get($dark, primary-text-color);
        }

        &.lightTheme {
            background-color: map_get($light, primary-background);
            color: map_get($light, primary-text-color);
        }

        &.choosen {
            opacity: 1;
            border: 2px red solid;
        }
    }
}
</style>



// WEBPACK FOOTER //
// GeneralForm.vue?b4435690